/* import __COLOCATED_TEMPLATE__ from './cards.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();